/* GORIT-60 / GORIT-61: Keep RIO thumbnail names and current state in sync with its gallery. */
(() => {
  const labelTemplate = document.currentScript.dataset.thumbnailLabel;
  const gallerySelector = '.rio-media-gallery';
  const thumbnailSelector = '.rio-hide-scrollbar [tabindex] > img';
  const labels = new WeakMap();
  const enhancedButtons = new WeakSet();

  function updateLabels() {
    document.querySelectorAll(gallerySelector).forEach((gallery) => {
      const images = Array.from(gallery.querySelectorAll(thumbnailSelector)).filter((image) => {
        const button = image.parentElement;
        return button.matches('button, [role="button"], [role="none"]');
      });

      const activeSlide = gallery.querySelector('.pwzrswiper-slide-active[data-index]');
      const activeIndex = activeSlide ? Number(activeSlide.getAttribute('data-index')) : -1;

      images.forEach((image, index) => {
        const button = image.parentElement;
        if (button.getAttribute('role') === 'none') button.setAttribute('role', 'button');
        enhancedButtons.add(button);

        if (index === activeIndex) {
          if (button.getAttribute('aria-current') !== 'true') button.setAttribute('aria-current', 'true');
        } else if (button.hasAttribute('aria-current')) {
          button.removeAttribute('aria-current');
        }

        const previousLabel = labels.get(image);
        const currentAlt = image.getAttribute('alt') || '';
        const description = currentAlt === previousLabel?.value
          ? previousLabel.description
          : currentAlt.trim();
        const label = labelTemplate
          .replace('[index]', index + 1)
          .replace('[total]', images.length) + (description ? ': ' + description : '');
        if (currentAlt !== label) image.setAttribute('alt', label);
        labels.set(image, { value: label, description });
      });
    });
  }

  function start() {
    updateLabels();
    new MutationObserver((mutations) => {
      if (mutations.some((mutation) =>
        mutation.target.closest?.(gallerySelector) ||
        Array.from(mutation.addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches(gallerySelector) || node.querySelector(gallerySelector))
        )
      )) updateLabels();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'alt', 'role', 'aria-label', 'class', 'data-index'],
    });

    // RIO already handles Enter; add Space activation for its div buttons.
    document.addEventListener('keydown', (event) => {
      const button = event.target;
      if (event.key !== ' ' || event.defaultPrevented || !enhancedButtons.has(button) || button.tagName === 'BUTTON') return;
      event.preventDefault();
      if (!event.repeat) button.click();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
